// extracted by mini-css-extract-plugin
export var container = "_gz-0";
export var content = "_gz-3";
export var customerTitle = "_gz-4";
export var empty = "_gz-5";
export var gray = "_gz-6";
export var header = "_gz-7";
export var info = "_gz-8";
export var loading = "_gz-2";
export var loadingCard = "_gz-9";
export var oneLine = "_gz-a";
export var personName = "_gz-e";
export var pillContainer = "_gz-b";
export var selected = "_gz-1";
export var text = "_gz-c";
export var twoLines = "_gz-d";
export var unread = "_gz-f";
export var unreadIndicator = "_gz-g";